<template>
  <div class="chart-container">
    <span :style="tooltipStyle" class="chart-tooltip">Você está aqui</span>
    <canvas ref="chart"></canvas>
  </div>
</template>

<style lang="scss">

</style>

<script>
import Chart from 'chart.js';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      tooltipStyle: {
        opacity: 0
      },
      chart: false,
      updateHightLight: true,
    };
  },
  mounted() {
    this.setChart();
  },
  methods: {
    setChart() {
      this.updateHightLight = true;
      this.chart = new Chart(this.$refs.chart, {
        type: 'line',
        responsive: true,
        maintainAspectRatio: true,
        data: {
          labels: this.incomes,
          datasets: [{
            data: this.incomeTaxes,
            fill: '#FFFFFF',
            borderWidth: (window.innerWidth < 768) ? 2 : 5,
            pointRadius: (window.innerWidth < 768) ? 3 : 8,
            lineTension: 0,
            backgroundColor: '#aabf0f',
            borderColor: '#aabf0f',
            pointBorderWidth:  (window.innerWidth < 768) ? 1 : 3,
            pointBorderColor: '#53297D',
            pointBackgroundColor: '#aabf0f',
          }],
        },
        options: {
          maintainAspectRatio: false,
          animation: {
            duration: 500,
            onComplete: () => {
              this.highLightPosition();
            },
          },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: (window.innerWidth < 768) ? '% de Imposto' : '% de Imposto Pago',
                fontColor: 'rgba(255, 255, 255, 0.6)',
                fontSize: 16,
              }, 
              gridLines: {
                drawBorder: true,
                lineWidth: 1,
                color: 'rgba(255, 255, 255, 0.3)',
              },
              ticks: {
                fontSize: (window.innerWidth < 768) ? 14 : 16,
                padding: (window.innerWidth < 768) ? 1 : 15,
                fontColor: "white",
                callback(item){
                  return item +'%';
                },
              },
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Renda mensal',
                fontColor: 'rgba(255, 255, 255, 0.6)',
                fontSize: 16,
              }, 
              gridLines: {
                display: (window.innerWidth < 768) ? true : false,
                lineWidth: 0.3,
                color: 'rgba(255, 255, 255, 0.5)',
              },
              ticks: {
                padding: (window.innerWidth < 768) ? 1 : 20,
                fontSize: (window.innerWidth < 768) ? 12 : 16,
                fontColor: "white",
                callback(item, index){
                  return item;
                },
              },
            }],
          },
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
        },
      });
    },
    highLightPosition(chart) {
      if (this.updateHightLight) {
        this.updateHightLight = false;

        const { chart } = this.$refs;
        const chartBounds = chart.getBoundingClientRect();
        const meta = this.chart.getDatasetMeta(0);
        const point = meta.data[this.highlightPointIndex];

        point.custom = point.custom || {};
        point.custom.backgroundColor = "#f770af";
        point.custom.radius = (window.innerWidth < 768) ? 3 : 8;
        point.custom.borderWidth = (window.innerWidth < 768) ? 3 : 10;
        point.custom.borderColor = 'rgb(247,112,175, 0.4)';

        this.tooltipStyle = {
          opacity: 1,
          top: (point._model.y / chartBounds.height) * 100 + '%',
          left: (point._model.x / chartBounds.width) * 100 + '%',
        }

        this.chart.update(0);
      };
    },
  },
  computed: {
    ...mapState(['income']),
    dataChart() {
      return this.income.chart;
    },
    highlightPointIndex() {
      return this.income.highlightIndex;
    },
    incomes() {
      return this.dataChart.map((item, idx) => {
        return item.axisx_title;
      });
    },
    incomeTaxes() {
      return this.dataChart.map((item) => {
        return Math.round(item.proportion_income_taxes * 100);
      });
    }
  },
  watch: {
    dataChart(to, from) {
      this.setChart();
    },
  },
};
</script>

<style lang="scss">
.chart-container {
  position: relative;

  min-height: rem-calc(300);

  @media #{$medium-up} {
    min-height: rem-calc(400);
  }
}

.chart-tooltip {
  position: absolute;
  top: 0;
  left: 0;

  text-align: center;
  white-space: nowrap;

  opacity: 0;
  background-color: $white;
  padding: rem-calc(5);
  border-radius: rem-calc(5);
  transform: translate(-50%, -200%);
  transition: opacity ease 0.3s, left ease 0.3s, top ease 0.3s;

  &:after {
    content: '';
    position: absolute;

    left: 50%;
    bottom: 0;

    width: 0;
    height: 0;
    border-style: solid;
    border-width: rem-calc(10 7.5 0 7.5);
    border-color: #ffffff transparent transparent transparent;

    transform: translate(-50%, 100%);
  }
}
</style>